
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HinaInput from "./baseComponent/hina-input.vue";
import HinaTextarea from "./baseComponent/hina-textarea.vue";
import Interview, {
  FormFields,
  ADD,
  EDIT
} from "@/lib/interview-experiment/index";
const DEFAULT_FORM = {
  configId: 0,
  taskName: "",
  originExamId: "",
  targetExamId: "",
  matchList: [[], []],
  range: "" // 灰度范围 字符串
};

@Component({
  components: { HinaInput, HinaTextarea }
})
export default class Dialog extends Vue {
  @Prop({}) type!: string;
  // title 有title就用新穿过来的title
  @Prop({}) title!: string;
  @Prop({}) visible!: boolean;
  @Prop({}) data!: object | null;
  @Prop({}) getList!: Function;
  localVisible = this.visible; // 初始化为 prop 的值
  stringList: string[] = []; // 灰度范围字符串数组
  _matchList: string[][] = [];
  count = 0; // 试验范围总计几条
  ruleForm: FormFields = {
    ...DEFAULT_FORM
  };
  ADD = ADD;
  EDIT = EDIT;
  rules = {
    taskName: [
      { required: true, message: "请输入任务名称", trigger: "blur" },
      { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
    ],
    originExamId: [
      { required: true, message: "请输入原面试ID", trigger: "blur" }
    ],
    targetExamId: [
      { required: true, message: "请输入灰度面试ID", trigger: "blur" }
    ],
    range: [
      {
        required: true,
        validator: this.checkRange,
        trigger: "blur"
      }
    ]
  };

  checkRange(rule: object, value: string, callback: Function): any {
    if (!value) {
      return callback(new Error("请输入灰度范围"));
    }
    const bool = this.check();
    if (!bool) {
      return callback(
        new Error(
          "您输入的灰度范围，不符合输入规则；\n输入规则如下： \n每一行只允许输入xx-xx-xx 或者xx-xx-* 或者 xx-*-*  ;(x代表空格外的任意字符)"
        )
      );
    } else {
      callback();
    }
  }

  @Watch("data", { immediate: true, deep: true })
  handleData(obj: object | null): void {
    // 存在说明是编辑态
    if (obj) {
      const range = this.transfer(obj.matchList); // 改变数据格式
      this.ruleForm = { ...obj, range };
    }
  }

  @Watch("visible", { immediate: true, deep: false })
  handleVisible(newValue: boolean): void {
    this.localVisible = newValue;
    this.$refs["ruleForm"]?.resetFields();
  }

  // 观察 range
  @Watch("ruleForm.range", { immediate: true, deep: false })
  handle(val: string): void {
    const lines = val.split("\n").filter(line => line.trim() !== "");
    // 去除前后的空格
    const _lines = lines.map(str => str.trim());
    this.stringList = _lines; // ["xx", "x"]
    this.count = lines.length; // 计算数量
  }

  changeFromStringToArray(): void {
    this._matchList = this.stringList.map(str => {
      const arr = str.split("-");
      return arr;
    });
    this.ruleForm.matchList = this._matchList; // 最后的规则
  }
  handleClose(): void {
    this.$emit("update:visible", false);
    // 为了让用户不认为除了bug，延迟200ms清空数据
    setTimeout(() => {
      this.$refs["ruleForm"].resetFields();
      this.ruleForm = {
        ...DEFAULT_FORM
      };
      this.count = 0;
      this.$emit("update:data", null);
    }, 200);
  }

  // 校验规则
  check(): boolean {
    const patterns = [
      /^[^\s-]+-[^\s-]+-[^\s-]+\s*$/, // 字符串-字符串-字符串，尾部允许有空格
      /^[^\s-]+-\*-\*\s*$/, // 字符串-*-*，尾部允许有空格
      /^[^\s-]+-[^\s-]+-\*\s*$/ // 字符串-字符串-*，尾部允许有空格
    ];

    function validateString(input: string): boolean {
      return patterns.some(pattern => pattern.test(input));
    }

    let boolean = true;

    this.stringList.forEach(el => {
      if (boolean) {
        boolean = validateString(el);
      }
    });
    return boolean;
  }

  // 将数组变成字符串
  transfer(matchList: string[][]): string {
    const _list = matchList.map((ele: Array<string>) => {
      return ele.join("-");
    });
    let str = _list.join("\n");
    return str;
  }

  submitForm(formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        this.submit();
      } else {
        return false;
      }
    });
  }

  submit(): void {
    this.changeFromStringToArray();
    const { range, ...res } = this.ruleForm;
    // 如果是创建和修改走save接口
    Interview.save(res)
      .then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.handleClose();
          this.getList(); // 重新获取列表
        }
      })
      .catch(error => {
        console.log("error: ", error);
      });
  }
}
